import axios from '../../utils/axios';

export default function fetchLGBillTargetsCount(adminId, params = {}) {
    console.log(params)
    return (
        axios.get(`/admin/${adminId}/allLGBillTargetsCount`,  {params} )
    )
}
